const verifyExistsEnum = {
  EmpresaNaoCadastrada: 0,
}

export default verifyExistsEnum
